import { Chip } from '@mui/material';
import type { InvoiceStatus } from '../../lib/invoices-api';
import { useT } from '../../i18n';

const COLORS: Record<InvoiceStatus, 'default' | 'warning' | 'error' | 'info' | 'success'> = {
  DRAFT: 'default',
  OPEN: 'warning',
  PAID: 'success',
  VOID: 'default',
  OVERDUE: 'error',
};

// status -> i18n key (shared by the invoices list / show / create pages).
export const INVOICE_STATUS_KEY: Record<InvoiceStatus, string> = {
  DRAFT: 'inv.statusDraft',
  OPEN: 'inv.statusOpen',
  PAID: 'inv.statusPaid',
  VOID: 'inv.statusVoid',
  OVERDUE: 'inv.statusOverdue',
};

export function InvoiceStatusChip({ status }: { status: InvoiceStatus }) {
  const t = useT();
  return <Chip label={t(INVOICE_STATUS_KEY[status])} color={COLORS[status]} size="small" variant="filled" />;
}
